/* eslint-disable */
export const settings = {
	app: {
		name: 'My News',
		version: '2.2.1'
	},
	theme: {
		skin: 'light' // possible values are light, dark
	}
};
export default { settings };
